import { Component, OnInit } from '@angular/core';
import * as Global from "src/app/global";

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  Global = Global;
  constructor() { }

  ngOnInit(): void {
  }

}
